<template>
  <Modal
    v-model="modalVisibile"
    width="416"
    :mask-closable="false"
    :title="modalTitle"
    @on-cancel="handleCancel"
  >
    <div slot="header">
      <span class="modal_title">{{modalTitle}}</span>
    </div>
    <div class="clearfix">
<!--      订单-->
      <Form label-position="right" v-if="type==0">
        <FormItem :label-width="90" label="订单信息:">
          <span class="form-text">{{param.order_no}}</span>
        </FormItem>
        <FormItem :label-width="90" label="标题:">
          <span class="form-text">{{param.title}}</span>
        </FormItem>
        <FormItem :label-width="90" label="作者昵称:">
          <span class="form-text">{{param.post_username}}</span>
        </FormItem>
        <FormItem :label-width="90" label="购买人昵称:">
          <span class="form-text">{{param.username}}</span>
        </FormItem>
        <FormItem :label-width="90" label="价格:">
          <span class="form-text">{{param.money}}</span>
        </FormItem>
      </Form>
<!--      文章-->
      <Form label-position="right" v-if="type==1">
        <FormItem :label-width="90" label="标题:">
          <span class="form-text">{{param.title}}</span>
        </FormItem>
        <FormItem :label-width="90" label="作者昵称:">
          <span class="form-text">{{param.username}}</span>
        </FormItem>
        <FormItem :label-width="90" label="购买数量:">
          <span class="form-text">{{param.views}}</span>
        </FormItem>
        <FormItem :label-width="90" label="文章价格:">
          <span class="form-text">{{param.money}}</span>
        </FormItem>
      </Form>
      <div class="line"></div>
      <Form ref="form" @submit.native.prevent :model="formData" :rules="rule" label-position="left" class="mytable-titleBox fl">
        <FormItem label="请输入登录密码" prop="pwd">
          <Input v-model="formData.pwd" type="password" placeholder="请输入密码" class="w290"></Input>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" @click="handleSubmit" :disabled="loading" :loading="loading">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'refund',
  props: ['modalTitle', 'id', 'type','param'],
  // props:{
  //   modalTitle:{
  //
  //   },
  //   id:{
  //
  //   },
  //   type:{
  //
  //   },
  //   param: {
  //     order_no:'',
  //     title: '',
  //     post_username: '',
  //     money: ''
  //   }
  // },
  data () {
    const validatePass = (rule, value, callback) => {
      let loginPwd = localStorage.getItem('abc')
      if (this.formData.pwd != loginPwd) {
        callback(new Error('密码错误'))
      }
      callback()
    }
    return {
      loading: false,
      modalVisibile: false,
      formData: {
        pwd: ''
      },
      rule: {
        pwd: [{
          message: '密码不能为空', required: true, trigger: 'blur'
        }, {
          validator: validatePass, trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    handleCancel () {
      this.modalVisibile = false
      this.$refs.form.resetFields()
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.type == 0) {
            // 订单
            this.$api.orderRefund({ id: this.id }).then(res => {
              if (res.code == 0) {
                this.$Message.success('申请退款成功')
                this.handleCancel()
                this.$emit('success')
              } else {
                this.$Message.error(res.msg)
              }
              this.loading = false
            })
          } else {
            // 文章
            this.$api.postRefund({ id: this.id }).then(res => {
              if (res.code == 0) {
                this.$Message.success('申请退款成功')
                this.handleCancel()
                this.$emit('success')
              } else {
                this.$Message.error(res.msg)
              }
              this.loading = false
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.w290{
  width: 290px;
}
  .line{
    border-bottom: 1px solid #d9d9d9;
  }
  /deep/ .ivu-modal-body{
    padding-top: 8px;
    padding-bottom: 20px !important;
  }
  /deep/ .ivu-form-item{
    margin-bottom: 0;
  }
</style>
